import { FC, ReactNode } from "react";
import { motion } from "framer-motion";

interface Props {
  icon: ReactNode;
  iconBg: string;
  title: string;
  description: string;
  footer?: ReactNode;
}

const StatusScreen: FC<Props> = ({ icon, iconBg, title, description, footer }) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center text-center px-4">
      <motion.div
        className={`mb-6 flex size-20 items-center justify-center rounded-full ${iconBg}`}
        initial={{ scale: 0.4, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 280, damping: 18, delay: 0.05 }}
      >
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 320, damping: 20, delay: 0.2 }}
        >
          {icon}
        </motion.div>
      </motion.div>
      <motion.h1
        className="text-2xl font-bold mb-2"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.28 }}
      >
        {title}
      </motion.h1>
      <motion.p
        className="text-muted-foreground max-w-md mb-4"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.38 }}
      >
        {description}
      </motion.p>
      {footer}
    </div>
  );
};

export default StatusScreen;
